import { getApiBaseUrl } from "../config/api";

export interface OriginalReport {
  available: boolean;
  report_text?: string | null;
}

/**
 * Fetch the original radiologist report for a study (`POST /api/original-report`).
 * The backend strips any `::job` suffix and scopes, audits and rate-limits access.
 * Shared by the case-viewer panel and the key-image review.
 */
export async function fetchOriginalReport(studyId: string, token: string): Promise<OriginalReport> {
  const response = await fetch(`${getApiBaseUrl()}/api/original-report`, {
    method: "POST",
    headers: { "Content-Type": "application/json", Authorization: `Bearer ${token}` },
    body: JSON.stringify({ study_id: studyId }),
  });
  if (!response.ok) throw new Error(`Original report request failed (${response.status})`);
  return (await response.json()) as OriginalReport;
}
